var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data && _vm.data.length
    ? _c("div", { staticClass: "main-page-news" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "container--header" }, [
            _c("h2", { domProps: { innerHTML: _vm._s(_vm.text.title) } }),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "link link--arrow",
                attrs: { href: "/press-center/news/" }
              },
              [
                _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.text.allNews) }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "main-page-news-slider" }, [
            _c(
              "div",
              { staticClass: "row row--40 swiper-wrapper" },
              _vm._l(_vm.data, function(item, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass:
                      "col-default-3 col-mobile-12 main-page-news-slide swiper-slide"
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "tile tile__link",
                        attrs: { href: item.link }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "tile__img tile__img--labels" },
                          [
                            _c("img", {
                              attrs: { src: item.image, alt: item.name }
                            }),
                            _vm._v(" "),
                            item["press-release"]
                              ? _c("span", {
                                  staticClass: "tile__img--tag",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.text.press)
                                  }
                                })
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "tile__body" }, [
                          _c("span", {
                            staticClass: "tile__title",
                            domProps: { innerHTML: _vm._s(item.name) }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "details" }, [
                            _c(
                              "time",
                              {
                                staticClass: "details__date",
                                attrs: {
                                  datetime: _vm._f("momentFilter")(item.date)
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("momentFilter")(
                                      item.date,
                                      "D MMMM YYYY"
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "details__body" }, [
                              _c("span", {
                                staticClass: "details__tag",
                                domProps: { innerHTML: _vm._s(item.type) }
                              })
                            ])
                          ])
                        ])
                      ]
                    )
                  ]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "container--line" })
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-063b9890", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-063b9890","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/components/main-page/components/news-list/index.vue
// module id = 114
// module chunks = 0